import { useCallback, useEffect, useState } from 'react';
import { fetchCatalog } from '../api/checkout';
import { useUnifiedAuth } from '../contexts/UnifiedAuthContext';

const defaultState = {
  products: [],
  recommendedBundles: [],
};

const useProductCatalog = () => {
  const { isAuthenticated, getApiToken } = useUnifiedAuth();
  const [catalog, setCatalog] = useState(defaultState);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCatalog = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = isAuthenticated ? await getApiToken() : null;
      const data = await fetchCatalog(token || undefined);
      setCatalog(data || defaultState);
    } catch (catalogError) {
      console.error('[useProductCatalog] Failed to load catalog', catalogError);
      setError(catalogError);
      setCatalog(defaultState);
    } finally {
      setLoading(false);
    }
  }, [getApiToken, isAuthenticated]);

  useEffect(() => {
    loadCatalog();
  }, [loadCatalog]);

  return {
    catalog,
    loading,
    error,
    refresh: loadCatalog,
  };
};

export default useProductCatalog;
